// Resolves after `ms`, or immediately once `signal` aborts. Shared by the
// site-action pollers (Configure Motion, Genetec alarm setup) so an aborted
// poll stops waiting as soon as the page that started it goes away.
export const abortableWait = (ms: number, signal?: AbortSignal) =>
  new Promise<void>((resolve) => {
    if (signal?.aborted) {
      resolve();
      return;
    }
    const done = () => {
      clearTimeout(timer);
      signal?.removeEventListener("abort", done);
      resolve();
    };
    const timer = setTimeout(done, ms);
    signal?.addEventListener("abort", done);
  });
